import { Stack, Typography, Box } from '@mui/material';
const DefinitionRow = ({ label, children }) => (
    <Stack
        direction={{ xs: 'column', md: 'row' }}

        sx={{
            py: 1,
            borderBottom: '1px solid',
            borderColor: 'divider',
        }}
    >
        <Typography
            sx={{
                minWidth: 200,
                color: 'text.secondary',
                fontSize: 14,
                display: 'flex',
                alignItems: 'center',
                mr: 2
            }}
        >
            {label}
        </Typography>
        <Box sx={{ flex: 1 }}>
            {children}
        </Box>
    </Stack>
);

export default DefinitionRow;